<template>
  <div class='lib__panel'>
    <header class='lib__panel__header'>
      <h3 class='lib__h3'>{{ $t('chargingStationDeclaration.information.station', { count: (index + 1).toString() })
        }}</h3>
    </header>
    <button v-if='canDelete' class='lib__panel__close' @click.prevent='remove'>
      <i class='far fa-trash-alt'></i>
    </button>
    <div class='lib__panel__main lib__panel__main--form'>
      <ValidationProvider v-slot='{ errors, passed, failed }' :rules="{ 'required': true}" slim>
        <div :class="[failed && 'lib__field--error', passed && 'lib__field--valid']" class='lib__field'>
            <label class='lib__field__label'>{{ $t('chargingStationDeclaration.information.declaration') }}</label>
          <div class='lib__tiles lib__tiles--inline'>
            <TileRadio
              v-model='value.inService'
              :group='"inService" + index'
              :item='true'
              :label="$t('chargingStationDeclaration.information.inService')">
            </TileRadio>
            <TileRadio
              v-model='value.inService'
              :group='"inService" + index'
              :item='false'
              :label="$t('chargingStationDeclaration.information.outService')">
            </TileRadio>

          </div>
          <error-message :error='errors[0]'></error-message>
        </div>
      </ValidationProvider>

      <DateBox v-model='value.inServiceDate' :label="$t('chargingStationDeclaration.information.inServiceDate')" required />

      <ValidationProvider v-slot='{ errors, passed, failed }' :rules="{ 'required': true}" slim>
        <div :class="[failed && 'lib__field--error', passed && 'lib__field--valid']" class='lib__field'>
          <label class='lib__field__label'>
            {{ $t('chargingStationDeclaration.information.usage') }}
            <div class="lib__tooltips" @click='usageModalOpen = true'>
                <span>
                  <i class="fas fa-info-circle lib__clickable-tooltips"></i>
                </span>
            </div>
          </label>
          <div class='lib__tiles lib__tiles--inline'>
            <TileRadio
              tiny
              v-model='value.usage'
              :group='"usage" + index'
              item='private'
              :label="$t('chargingStationDeclaration.information.privateStation')">
              <template v-slot:picture>
                <i class='fas fa-home'></i>
              </template>
            </TileRadio>
            <TileRadio
              tiny
              v-model='value.usage'
              :group='"usage" + index'
              item='public'
              :label="$t('chargingStationDeclaration.information.publicStation')">
              <template v-slot:picture>
                <i class='fas fa-landmark'></i>
              </template>
            </TileRadio>
          </div>
          <error-message :error='errors[0]'></error-message>
        </div>
      </ValidationProvider>

      <ValidationProvider v-slot='{ errors, passed, failed }' :rules="{ 'required': true}" slim>
        <div :class="[failed && 'lib__field--error', passed && 'lib__field--valid']" class='lib__field'>
          <label class='lib__field__label'>
            {{ $t('chargingStationDeclaration.information.bidirectional') }}
            <div class="lib__tooltips" @click='bidirectionalModalOpen = true'>
                <span>
                  <i class="fas fa-info-circle lib__clickable-tooltips"></i>
                </span>
            </div>
          </label>
          <div class='lib__tiles lib__tiles--inline'>
            <TileRadio
              tiny
              v-model='value.biDirectional'
              :group='"biDirectional" + index'
              :item='true'
              :label="$t('common.yes')">
              <template v-slot:picture>
                <i class='fas fa-check'></i>
              </template>
            </TileRadio>
            <TileRadio
              tiny
              v-model='value.biDirectional'
              :group='"biDirectional" + index'
              :item='false'
              :label="$t('common.no')">
              <template v-slot:picture>
                <i class='fas fa-times'></i>
              </template>
            </TileRadio>

          </div>
          <error-message :error='errors[0]'></error-message>
        </div>
      </ValidationProvider>

      <ValidationProvider v-slot='{ errors, passed, failed }' :rules="{ 'required': true}" slim>
        <div :class="[failed && 'lib__field--error', passed && 'lib__field--valid']" class='lib__field'>
          <label class='lib__field__label'>
            {{ $t('chargingStationDeclaration.information.isSmart') }}
            <div class="lib__tooltips" @click='smartModalOpen = true'>
                <span>
                  <i class="fas fa-info-circle lib__clickable-tooltips"></i>
                </span>
            </div>
          </label>
          <div class='lib__tiles lib__tiles--inline'>
            <TileRadio
              tiny
              v-model='value.isSmart'
              :group='"isSmart" + index'
              :item='true'
              :label="$t('common.yes')">
              <template v-slot:picture>
                <i class='fas fa-check'></i>
              </template>
            </TileRadio>
            <TileRadio
              tiny
              v-model='value.isSmart'
              :group='"isSmart" + index'
              :item='false'
              :label="$t('common.no')">
              <template v-slot:picture>
                <i class='fas fa-times'></i>
              </template>
            </TileRadio>
          </div>
          <error-message :error='errors[0]'></error-message>
        </div>
      </ValidationProvider>

      <div class='row'>
        <div class='col-xs-12 col-md-6'>
          <text-box-data-list v-model='value.brand' :default-ctor='createDefaultBrand' :list='brands'
                              :label="$t('chargingStationDeclaration.information.brand')" property-name='brand' required />
        </div>
        <div class='col-xs-12 col-md-6'>
          <text-box-data-list v-model='value.model' :list='models' :label="$t('chargingStationDeclaration.information.model')" required />
        </div>
        <div class='col-xs-12 col-md-6'>
          <select-box v-model='value.power' :options='powers' :label="$t('chargingStationDeclaration.information.power')" required show-tooltip @tooltipClick='powerModalOpen = true' />
        </div>
        <div class='col-xs-12 col-md-6'>
          <select-box v-model='value.plug' :options='plugs' :label="$t('chargingStationDeclaration.information.plug')" required show-tooltip @tooltipClick='plugModalOpen = true' />
        </div>
      </div>
    </div>

    <ModalDialog :closeable="$t('common.close')" :open.sync='usageModalOpen'>
      <h3>{{ $t('chargingStationDeclaration.information.modal.usage.title') }}</h3>
      <p v-html="$t('chargingStationDeclaration.information.modal.usage.text1')" />
      <p v-html="$t('chargingStationDeclaration.information.modal.usage.text2')" />
    </ModalDialog>

    <ModalDialog :closeable="$t('common.close')" :open.sync='bidirectionalModalOpen'>
      <h3>{{ $t('chargingStationDeclaration.information.modal.bidirectional.title') }}</h3>
      <p v-html="$t('chargingStationDeclaration.information.modal.bidirectional.text1')" />
      <p v-html="$t('chargingStationDeclaration.information.modal.bidirectional.text2')" />
    </ModalDialog>

    <ModalDialog :closeable="$t('common.close')" :open.sync='smartModalOpen'>
      <h3>{{ $t('chargingStationDeclaration.information.modal.smart.title') }}</h3>
      <p v-html="$t('chargingStationDeclaration.information.modal.smart.text1')" />
    </ModalDialog>

    <ModalDialog :closeable="$t('common.close')" :open.sync='powerModalOpen'>
      <h3>{{ $t('chargingStationDeclaration.information.modal.power.title') }}</h3>
      <p v-html="$t('chargingStationDeclaration.information.modal.power.text1')" />
    </ModalDialog>

    <ModalDialog :closeable="$t('common.close')" :open.sync='plugModalOpen'>
      <h3>{{ $t('chargingStationDeclaration.information.modal.plug.title') }}</h3>
      <p v-html="$t('chargingStationDeclaration.information.modal.plug.text1')" />
    </ModalDialog>
  </div>
</template>

<script lang='ts'>
import Component from 'vue-class-component'
import { Emit, Prop, Vue } from 'vue-property-decorator'
import { ChargingStationInformation, ChargingStationSpecification } from '@/models/charging-station-declaration'

@Component({
  name: 'charging-station-information'
})
export default class ChargingStationInformationComponent extends Vue {
  @Prop({ type: Object, required: true }) public readonly value!: ChargingStationInformation
  @Prop({ type: Number, required: true }) public readonly index!: number
  @Prop({ type: Boolean, required: true }) public readonly canDelete!: number

  public brands: ChargingStationSpecification[] = []
  public powers: Array<{ text: string; value: number }> = []
  public plugs: Array<{ text: string; value: number }> = [
    { text: '1', value: 1 },
    { text: '2', value: 2 },
    { text: '3', value: 3 },
    { text: '4', value: 4 }]

  public usageModalOpen: boolean = false
  public bidirectionalModalOpen: boolean = false
  public smartModalOpen: boolean = false
  public powerModalOpen: boolean = false
  public plugModalOpen: boolean = false

  public get models(): string[] {
    return this.value.brand ? this.value.brand.models : []
  }

  public mounted() {
    this.fetchBrandsAndModels()
    this.fetchPowers()
  }

  public async fetchBrandsAndModels() {
    const response = await this.$api.get<ChargingStationSpecification[]>('ChargingStationDeclaration/specifications')
    this.brands = response.data
  }

  public async fetchPowers() {
    const response = await this.$api.get<number[]>('ChargingStationDeclaration/powers')
    this.powers = response.data.map((d) => {
      return {
        text: `${d.toString()} kW`,
        value: d
      }
    })
    this.powers.push({
      text: this.$tc('common.other'),
      value: -1
    })
  }

  public createDefaultBrand(text: string | null): ChargingStationSpecification | null {
    if (!text) {
      return null
    }

    return {
      brand: text,
      models: []
    }
  }

  //#region [Emit]
  @Emit('remove')
  public remove(): void {
    return undefined
  }

  //#endregion
}
</script>
